import DoorDetailsPage from './pages/DoorDetails.page';

DoorDetailsPage.path = '/doors/:id';

export default {
  pages: {
    DoorDetailsPage,
  }
};
